export const ru = {
    'title': 'Список шаблонов',
    'new-template': 'Новый шаблон',
    'create': 'Создать'
};
